export const BRAND_COLOR = '#3d6560';

export const COLOR_PALETTE = [
  '#3d6560',
  '#5a8b84',
  '#7aa8a0',
  '#9bc5bd',
  '#bce2da',
] as const;

export const USER_ROLE_COLORS: Record<string, string> = {
  CARE_SEEKER: '#3d6560',
  FINANCIAL_ADVISOR: '#5a8b84',
  SERVICE_PROVIDER: '#7aa8a0',
  ADMIN: '#9bc5bd',
};

export const USER_ROLE_LABELS: Record<string, string> = {
  CARE_SEEKER: 'Care Seekers',
  FINANCIAL_ADVISOR: 'Financial Advisors',
  SERVICE_PROVIDER: 'Service Providers',
  ADMIN: 'Admins',
};

// Dark-green banner gradient (e.g. the FP "Advisor-Driven Referral Value" card).
export const GRADIENT_BANNER = {
  from: '#2c4a46',
  to: '#3d6560',
} as const;
